import { useIntl } from '@redbubble/next/intl';
import { useInView } from 'react-intersection-observer';
import { AddToListButton } from '../AddToListButton';
import { Price } from '../Price';
import { ProductCard } from '../ProductCard';
import {
  CarouselSectionDataType,
  useCarouselSectionContext,
} from './carouselSectionContext';

export const CarouselMediaCard = ({
  data,
  index,
  isLast,
  searchUUID,
}: {
  data: CarouselSectionDataType;
  index: number;
  isLast?: boolean;
  searchUUID?: string | null;
}) => {
  const intl = useIntl();
  const { mediaCardPropsMapper, pricePropsMapper, analytics } =
    useCarouselSectionContext();

  const mediaCardProps = mediaCardPropsMapper(data, intl, index);

  const { ref } = useInView({ triggerOnce: true });

  if (!mediaCardProps) return null;

  const {
    key,
    testId,
    title,
    caption,
    link,
    imageSrc,
    workTitle,
    artistName,
    matureContent,
    tags,
    addToListButtonProps,
    hideLink,
    onClick,
    stockStatus,
  } = mediaCardProps;

  if (!link || !imageSrc) return null;

  const price = pricePropsMapper ? pricePropsMapper(data) : null;

  return (
    <div ref={isLast ? ref : null}>
      <ProductCard
        onClick={onClick}
        key={key}
        analyticsIndex={index}
        analyticsComponentID={analytics.listID}
        testId={testId ?? undefined}
        title={title}
        caption={caption}
        link={link}
        imageSrc={imageSrc}
        workTitle={workTitle ?? ''}
        artistName={artistName}
        matureContent={matureContent}
        hideLink={hideLink}
        tags={tags}
        zoomOnHover
        stockStatus={stockStatus}
        primaryAction={
          addToListButtonProps && (
            <AddToListButton
              inventoryItem={addToListButtonProps.inventoryItem}
              workId={addToListButtonProps.workId}
              onAddToList={addToListButtonProps.onAddToList}
              listsInclusions={addToListButtonProps.listsInclusions}
              analyticsComponentID={analytics.listID}
              analyticsIndex={index}
              searchUUIDStorageKey={analytics.searchUUIDStorageKey}
            />
          )
        }
        searchUUID={searchUUID}
      >
        {price && (
          <Price
            size="small"
            textAlign="right"
            discount={price.discount}
            amount={price.amount}
            currency={price.currency}
            hideVATOverride
            variant={price.variant}
          />
        )}
      </ProductCard>
    </div>
  );
};
